/**
 * Module GameModelLocator
 * manager of GameItem classes and keeper of 'current game'
 *
 * Accessing just about any data from or property of a game is passed through this class
 * This class, as of right now, just sorta mixes itself into the GameDayCore object
 * It's not super kosher but it's one of the first classes I tried to move over from the 2 Gamedays so give me a break
 */
define(function (require, exports, module) {
    // dependency require imports
    var exists = require('extant/extant');
    var logg = require('../utils/core-log');
    var GameId = require('gid-decoder/GidDecoder');

    // project level require imports
    var GameItem = require('../load/store/GameItem');
    var TfsManager = require('./TfsManager');

    var gameItems = {};
    var currentGame;

    var UNDEF = undefined; // eslint-disable-line no-undef-init

    /**
     * Function getGame
     * @param gameID {String} game you want to Load
     * @returns {GameItem}
     *
     * This delivers a GameItem object.
     * If the game is already the 'current' (ie active) game, it just delivers that as if you called getCurrent()
     * If the game exists but is idle, it activates the one requested and returns it
     * If the game requested does not yet exist, it creates it and returns it
     *
     * In all cases if whatever game is current is not the one requested, it deactivates that game in favor of the new one
     */
    exports.getGame = function (gameID) {
        var newGame;

        gameID = GameId(gameID).storeVal;
        logg.log('get game by ID: ' + gameID);

        // you give nothing, you get nothing
        if (!exists(gameID)) {
            return null;
        }
        // return the current game if that's what they asked for
        if (exists(currentGame) && exists(gameItems[gameID]) && gameID === currentGame.gameID) {
            if (!currentGame.heartbeatItem.isActive()) {
                currentGame.heartbeatItem.start();
            }
            return currentGame;
        }

        // stop the current game polling if we are requesting a new game
        if (exists(currentGame) && gameID !== currentGame.gameID) {
            var game;
            // Shut em all down, in case of rapid switching
            for (game in gameItems) {
                if (gameItems[game].active()) {
                    gameItems[game].stopHeartbeat();
                }
            }
        }

        // if there is not already a game for that id...
        newGame = gameItems[gameID];
        if (!exists(newGame)) {
            logg.log('creating new game instance');

            newGame = new GameItem(gameID);
            gameItems[gameID] = newGame;
        } else {
            logg.log('game already exists');
        }
        // GameItems are smart... let them decide what to do
        currentGame = newGame;
        newGame.init();

        return currentGame;
    };

    exports.destroyGame = function (gameID) {
        gameID = GameId(gameID).storeVal;
        gameItems[gameID].destroyGame(); // Destroy model cache item on the GameItem (ModelCache item)
        delete gameItems[gameID]; // Then destroy game in game model cache in Locator..
    };

    exports.retrieveGameFromCache = function (gameID) {
        return gameItems[GameId(gameID).storeVal];
    };
    /**
     * Function getCurrentGame
     * @returns {GameItem} can return null/undefined if there is no active game
     *
     * basic retreiver for the active game item
     */
    exports.getCurrentGame = function () {
        return currentGame;
    };

    /**
     * Function getGameData
     * @param flavor {*} Usually a string of what data you would like returned but also works with object or array or comma-separated string
     * @returns the the game model in whole or in part as delivered from the 'active' game
     */
    exports.getGameData = function (flavor) {
        if (exists(currentGame)) {
            return currentGame.getGameData(flavor);
        } else {
            return null;
        }
    };

    /**
     * Function requestGameData
     * @param flavor {*} Usually a string of what data you would like returned but also works with object or array or comma-separated string
     * @param params {Object} additional needed parameters to be mixed in for the Load path (eg Player ID)
     * @returns {Promise} a nice happy promise for you to hug and hold and attach callbacks to.
     *
     * initiates a request for a data Load that will result in an event under the returned unique event ID
     */
    exports.requestGameData = function (flavor, params) {
        if (currentGame) {
            return currentGame.requestGameData(flavor, params);
        }
        // We don't have bad promises... just happy little accident promies.
        logg.warn('there was no game to get data from, so you you get a rejected promise... hope you like it.');
        return Promise.reject(null);
    };

    /**
     * Function switchGame
     * @param gid {String} game id to Load
     * @param startTimecode {String} any sort of timecode string from 2-6 characters with an option 'et' for eastern time
     * @param tfsStart {Boolean} true for timecode advance, false for stay put
     *
     * hotswap game
     */
    exports.switchGame = function (gid, startTimecode, tfsStart) {
        // Stop tfs sync while we switch
        if (TfsManager.syncActive()) {
            TfsManager.stopSync();
        }

        if (startTimecode !== null) {
            if (tfsStart !== UNDEF) {
                TfsManager.setTimerAdvanceOption(tfsStart);
            }
            if (startTimecode !== UNDEF) {
                TfsManager.setTimecode(startTimecode, true);
            }
            // start it up again
            TfsManager.beginSync(true);
        }

        if (exists(gid)) {
            var newGame = exports.getGame(gid);
            if (newGame && newGame.isPassive) {
                newGame.executePassiveLoad();
            }
        }
    };
});
